import { Button } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import ApproveProposalButton from "../../components/ApproveProposalButton";
import { StepPage } from "../../components/StepPage";
import { useResponsive } from "../../contexts";
import { useStore, useStoreActions } from "../../../contexts";
import { selectors } from "../../../store/state-selectors";
import { AgreementTerms } from "../AgreementTerms/AgreementTerms";
import { COBStep, getNextStepButtonText, getStepName, isApproveProposalDisabled } from "../ClientOnboarding.utils";
import { useCobConfig } from "../CobConfigContext";
import { jsx as _jsx } from "react/jsx-runtime";
export const {
  ApproveTermsStepTestIds
} = getTestIds();
export default function ApproveTermsStep(_ref) {
  let {
    isLastStep,
    selectedBundleID,
    disabledReason,
    approveAgreementStatus,
    selectedOptionalServices,
    previewStatus,
    onDone,
    onBack,
    approveAgreement
  } = _ref;
  const {
    relationship,
    isPreview
  } = useCobConfig();
  const {
    logBI
  } = useStoreActions();
  const {
    isDesktop
  } = useResponsive();
  const userId = useStore(selectors.user.id);
  const role = useStore(selectors.user.role);
  const nextStepButtonText = getNextStepButtonText(COBStep.approveTerms, relationship);
  const disabled = isApproveProposalDisabled(disabledReason, isPreview, relationship, userId, role);
  return /*#__PURE__*/_jsx(StepPage, {
    header: getStepName(COBStep.approveTerms, relationship),
    primaryBtn: isLastStep ? /*#__PURE__*/_jsx(ApproveProposalButton, {
      onDone: approveAgreement,
      previewStatus: previewStatus,
      isDesktop: isDesktop,
      relationship: relationship,
      testId: relationship.isSample ? ApproveTermsStepTestIds.TestAgreementPrimaryNextButton() : ApproveTermsStepTestIds.PrimaryNextButton(),
      disabled: disabled || approveAgreementStatus === 'loading'
    }) : /*#__PURE__*/_jsx(Button, {
      onClick: () => {
        !isPreview && logBI(10822);
        onDone();
      },
      children: nextStepButtonText
    }),
    disabledReason: disabled ? disabledReason : undefined,
    onBackBtnClick: onBack,
    testId: ApproveTermsStepTestIds.Root(),
    children: /*#__PURE__*/_jsx(AgreementTerms, {
      relationship: relationship,
      selectedBundleID: selectedBundleID,
      selectedOptionalServices: selectedOptionalServices
    })
  });
}